import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const GENERAL_FRAGMENT: TypedDocumentNode<AbTestsVariantsSchemaDTO['general']> = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment abTestsVariantsGeneralFragment on AbTestsVariantsGeneral {
    customCode {
      label
      codeAfter {
        ...abTestsVariantsAttributesFragment
      }
      codeBefore {
        ...abTestsVariantsAttributesFragment
      }
      customCodeEnabled {
        ...abTestsVariantsAttributesFragment
      }
    }
    label
  }
`
